export const formatPhoneNumber = (numStr) => {
  const cleaned = ("" + numStr).replace(/\D/g, "");

  const length = cleaned.length;

  if (length === 0) return "";
  if (length <= 3) return `(${cleaned}`;
  if (length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  if (length <= 10)
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6,
    )}`;

  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
    6,
    10,
  )}`;
};
